import styled from "@emotion/styled"
import {breakpoints} from "@next/ux-fabric"

export const BackgroundContainer = styled("div")`
    width: 100%;
    @media (min-width: ${breakpoints.values.md}px) and (max-width: ${breakpoints.values.lg}px) {
        height: 100%;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        min-height: 30rem;
        max-height: calc(100vh - 7rem);
        overflow-y: hidden;
        display: flex;
        flex-direction: column;
    }
`
